import React, { useEffect, useState } from "react";
import Layout from "../components/layout";
import { Typography, Container, Grid, Box, Hidden } from "@material-ui/core";
import CartItem from "../components/cart.js";
import { useTheme } from "@material-ui/core/styles";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import { useStaticQuery, graphql } from "gatsby";
import CircularProgress from "@material-ui/core/CircularProgress";
import { Link } from "gatsby";
import {
  getCart,
  get_cart_total,
  remove_from_cart,
  update_cart,
} from "../utils/cart";
import { useCookies } from "react-cookie";
import Img from "gatsby-image";

const Cart = () => {
  const theme = useTheme();
  const md = useMediaQuery(theme.breakpoints.up("md"));
  const [cart, setCart] = useState([]);
  const [cookies, setCookie] = useCookies(["tsa_cart"]);
  const [loading, setLoading] = useState(true);
  const [total, setTotal] = useState(0);
  const isMobile = useMediaQuery("(max-width: 960px)");

  const image = useStaticQuery(graphql`
    query {
      cart: file(relativePath: { eq: "hero/hero2.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 1980, maxHeight: 650, quality: 100) {
            ...GatsbyImageSharpFluid_withWebp_tracedSVG
            presentationWidth
          }
        }
      }
    }
  `);

  useEffect(() => {
    const loadCart = async () => {
      console.log(cookies.tsa_cart);
      getCart(cookies.tsa_cart).then((res) => {
        setCart(res.items || []);
        setTotal(res.totals.total);
        setLoading(false);
      });
    };
    loadCart();
  }, []);

  const decreaseQuantity = async (product) => {
    setLoading(true);
    const newCart = await update_cart(
      product,
      cookies.tsa_cart,
      product.quantity - 1
    ).then((res) => {
      setTotal(res.totals.total);
      setCart(res.items);
      setLoading(false);
    });
  };

  const increaseQuantity = async (product) => {
    setLoading(true);
    update_cart(product, cookies.tsa_cart, product.quantity + 1).then((res) => {
      setTotal(res.totals.total);
      setCart(res.items);
      setLoading(false);
    });
  };

  const removeFromCart = async (product) => {
    setLoading(true);
    remove_from_cart(product, cookies.tsa_cart).then((res) => {
      setLoading(false);
      setCart(res);
    });
  };

  return (
    <Layout>
      <Grid container style={{ minHeight: "90vh" }}>
        <Grid
          container
          item
          xs={12}
          md={8}
          lg={7}
          style={{
            margin: "30px 0px",
            paddingRight: isMobile ? "0px" : "30px",
          }}
        >
          <Container>
            {/* Header */}
            <Grid item xs={12} style={{ marginBottom: 20 }}>
              <Typography variant="h1">Your Cart</Typography>
            </Grid>
            {/* Cart Contents */}
            <Grid item container xs={12} style={{ position: "relative" }}>
              {loading && (
                <Grid
                  item
                  container
                  xs={12}
                  style={{
                    position: "absolute",
                    backgroundColor: "rgba(255,255,255,0.7)",
                    height: "100%",
                  }}
                  justify="center"
                  alignItems="center"
                >
                  <Grid item xs={12} align="center">
                    <CircularProgress color="primary" />
                  </Grid>
                </Grid>
              )}
              {/* Cart Items */}
              {cart && cart.length > 0 ? (
                cart.map((product) => {
                  return (
                    <CartItem
                      product={product}
                      increaseQuantity={increaseQuantity}
                      decreaseQuantity={decreaseQuantity}
                      removeFromCart={() => removeFromCart(product)}
                      key={product.product_id}
                    />
                  );
                })
              ) : (
                <Typography variant="body1" style={{ margin: "80px 0px" }}>
                  You have no items in your cart
                </Typography>
              )}
              {/* Sub Total */}
              <Grid
                item
                container
                justify="space-between"
                alignItems="center"
                xs={12}
                style={{
                  border: "2px solid rgb(240,240,240)",
                  borderBottom: 0,
                  borderRight: 0,
                  borderLeft: 0,
                  paddingTop: 10,
                }}
              >
                <Grid item xs={4}>
                  <Typography variant="body2">Sub total</Typography>
                </Grid>
                <Grid item xs={8} align="right">
                  <Typography
                    variant="body1"
                    style={{ fontWeight: 700, fontSize: 20 }}
                  >
                    {total}
                  </Typography>
                </Grid>
              </Grid>
              {/* Continue to checkout */}
              <Grid
                item
                xs={12}
                container
                justify={md ? "flex-end" : "center"}
                style={{ marginTop: 30 }}
              >
                <a
                  href={`https://app.takeshapeadventures.com.au/place-order/?cocart-load-cart=${cookies.tsa_cart}`}
                >
                  <Grid
                    item
                    xs={12}
                    style={{
                      background: "#ff1744",
                      borderRadius: 60,
                      padding: "16px 24px",
                    }}
                  >
                    <Typography
                      variant="h3"
                      align="center"
                      style={{
                        color: "white",
                        textTransform: "uppercase",
                        fontSize: 16,
                        fontWeight: 700,
                      }}
                    >
                      Continue to Checkout
                    </Typography>
                  </Grid>
                </a>
              </Grid>
            </Grid>
          </Container>
        </Grid>
        <Grid container item lg={5} md={4}>
          <Img
            fluid={image.cart.childImageSharp.fluid}
            style={{ width: "100%", height: "100%" }}
          />
        </Grid>
      </Grid>
    </Layout>
  );
};
export default Cart;
